import React, { useEffect ,useState} from 'react';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { useNavigate ,useLocation, Link} from "react-router-dom";
import BlckMembInqApi from 'Apis/BlckMembInqApi';
import MbpAthnUi from 'Utils/MbpAthn';
import MgpStore from 'Stores/Store';
import MbpAthnRsltVrfRqstApi from 'Apis/MbpAthnRsltVrfRqstApi';
import 'Assets/css/BlckMemb.css';
import { Helmet } from 'react-helmet-async';

const AppDrmcMembUi = () => {
    const location = useLocation(); 
    const navigate = useNavigate();
    const [blckMembState, setBlckMembState] = useState<any>();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    useEffect(()=>{
        BlckMembInqApi(location.state?.loginId).then((resp)=>{
            ;
            setBlckMembState(resp.apiBody);
        });
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                
                switch (resp.apiBody.athnPrpsCd) {
                    case "MEMB_DRMC":
                        navigate("/", { replace: true });
                    break;

                }   
            });
        }      
        window.kmcRespFunc = kmcRespFunc; 
    },[MgpStore.getState().LangSetState.Lang]);
    return(
        <>
        <Helmet>
            <title>BE@RBRICK CONNECT - Reprocess Member</title>
        </Helmet>
        <div className='BgW'>
            <div className='membFindTitl'>
                <h1>{langData&&langData.LOGIN_RE_PROC_MAIN_TITL_00}</h1>
                <div className='blckMembIcon'>
                    <img src={process.env.PUBLIC_URL+"/images/login/otpAthnIcon.png"} alt="블럭회원 아이콘" />
                </div>
            </div>
            <div className='blckNoticeWrap'>
                <p className='blckKindNm'>
                    {langData&&langData.LOGIN_RE_PROC_MAIN_DESC_00}
                </p>
            </div>
            <div className='mt50'>
                <MbpAthnUi athnPrpsCd={"MEMB_DRMC"} loginId={null} AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}/>
            </div>
        </div>
        </>
    )
}

export default AppDrmcMembUi;